<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar ref="system-bar" />
      </div>
      <div class="flex-fill overflow-auto">
        <Detail class="px-5 mt-3" />
        <v-list three-line>
          <v-list-item-group active-class="primary--text">
            <v-list-item
              class="px-5"
              @click="tryAgain()"
              v-if="canAction(LobbyAction.RETRY_CALL) && $store.state.categorySettings.call && $organization.directCallModule() && !$route.query.organizationSchedule && !directCallDisabled"
            >
              <v-list-item-icon>
                <Icon
                  :size="26"
                  color="primary"
                  icon="video-outline"
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{$t('basics.tryAgain.label')}}
                </v-list-item-title>
                 <v-list-item-subtitle style="line-height: 1.5">
                  {{ $t('basics.tryAgain.description') }}
                </v-list-item-subtitle>
                <v-list-item-subtitle style="line-height: 1.5">
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="canAction(LobbyAction.SCHEDULE) && $store.state.categorySettings.calendar && $organization.calendaryModule()"></v-divider>
            <v-list-item
              class="px-5"
              @click="calendar()"
              v-if="canAction(LobbyAction.SCHEDULE) && $store.state.categorySettings.calendar && $organization.calendaryModule() && $store.state.calendar.events.list.length !== 0"
            >
              <v-list-item-icon>
                <Icon
                  :size="26"
                  color="primary"
                  icon="calendar"
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('attentionTypes.scheduled.label') }}
                </v-list-item-title>
                <v-list-item-subtitle style="line-height: 1.5">
                  {{ $t('basics.scheduled.description') }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <div class="mx-5 my-5">
          <div class="action text-center">
            <v-btn
              class="font-weight-bold os-rounded"
              type="button"
              block
              depressed
              @click="$refs['system-bar'].reset()"
            >
              {{ $t('basics.exit') }}
            </v-btn>
          </div>
        </div>
        <v-divider v-if="canAction(LobbyAction.REQUEST_CONTACT) && $organization.contactCenter()"></v-divider>
        <ContactRequestForm
          class="mx-5 mt-5"
          v-if="canAction(LobbyAction.REQUEST_CONTACT) && $organization.contactCenter()"
        />
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import { LobbyAction } from '@/types/lobby-action.type'

@Component({
  computed: {
    availableActions () {
      return this.$store.state.call.availableActions
    },
    cammerAvailableGroupByCategory() {
      return this.$store.state.organization.cammerAvailableGroupByCategory
    },
    category() {
      return this.$store.state.storage.category
    },
    directCallDisabled () {
      const { isActive, data } = this.$organization.detectCammerAvailability()

      let disabled = false

      if (isActive && data?.lobby === 'true') {
        const categoryId = this.category && this.category.uuid ? this.category.id : null

        if (categoryId) {
          const categoryGroup = this.cammerAvailableGroupByCategory.find((item) => item.categoryId === categoryId)
          disabled = !categoryGroup
        } else {
          disabled = !this.cammerAvailableGroupByCategory.length
        }
      }

      return disabled
    }
  },
  components: {
    ContactRequestForm: () => import(/* webpackPrefetch: true */ '@/views/lobby/components/contact-request/Form.vue'),
    Detail: () => import(/* webpackPrefetch: true */ '@/views/lobby/components/Detail.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    ViewHeader: () => import(/* webpackPrefetch: true */ '@/components/ViewHeader.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})
export default class Index extends Vue {
  LobbyAction = LobbyAction

  canAction (action) {
    return this.availableActions === null || this.availableActions.includes(action)
  }

  tryAgain () {
    this.$router.replace({ path: '/calling' })
  }

  calendar () {
    this.$router.replace({ path: '/calendar' })
  }
}
</script>
